import { render, staticRenderFns } from "./chaternew.vue?vue&type=template&id=b108bb44&scoped=true"
import script from "./chaternew.vue?vue&type=script&lang=js"
export * from "./chaternew.vue?vue&type=script&lang=js"
import style0 from "./chaternew.vue?vue&type=style&index=0&id=b108bb44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b108bb44",
  null
  
)

export default component.exports